module.exports = __webpack_public_path__ + "static/media/Cluster-3_2000.cc478692.jpg";